/**
 * @fileoverview Run Details Hook
 * @description Loads the row-level detail content of a run from IndexedDB.
 * @module features/ScoutEval/utils/useRunDetails
 */

import { useEffect, useState } from 'react';
import { loadRunDetails } from './scoutDetailStore';

/**
 * Read the detail content of a run.
 * @param {string} runId - Run identifier.
 * @returns {Object|undefined} Detail content keyed by group id, undefined while loading.
 */
export function useRunDetails(runId) {
  const [entry, setEntry] = useState(null);

  useEffect(() => {
    let active = true;
    loadRunDetails(runId).then((details) => {
      if (active) {
        setEntry({ runId, details });
      }
    });
    return () => { active = false; };
  }, [runId]);

  return entry?.runId === runId ? entry.details : undefined;
}

export default useRunDetails;
